'use strict';

function PhoneNumbers(presenter, initCallback) {
  this.presenter = presenter;
  this._onPhoneNumbersReadyCallbacks = [];

  this._constructor = function (initCallback) {
    if (this.presenter.hasAction('account.phone_number_history')) {
      if (initCallback) this._onPhoneNumbersReadyCallbacks.push(initCallback);
      if (typeof this.presenter.models.account_phone_numbers === 'undefined' || !this.presenter.models.account_phone_numbers._initialized) {
        this.presenter.createModel('account_phone_numbers', { action: 'account.phone_number_history' }, this._onGetPhoneNumbersModel.bind(this));
      } else {
        this._onGetPhoneNumbersModel();
      }
    }
  };

  this._onGetPhoneNumbersModel = function (data, response) {
    // Perform the action on init for when the model is created but the action is
    this.presenter.performAction('account_phone_numbers.self', null, this._onPhoneNumbersModelUpdate.bind(this, data, response));
  };

  this._onPhoneNumbersModelUpdate = function (data, response) {
    this.parsePhoneNumbersModel();

    for (var i = 0; i < this._onPhoneNumbersReadyCallbacks.length; i++) {
      this._onPhoneNumbersReadyCallbacks[i](data, response);
    }
  };

  this.parsePhoneNumbersModel = function () {
    var _phoneNumberHistoryData = this.presenter.getModelProperty('account_phone_numbers.phone_number_history');
    if (!_phoneNumberHistoryData) return false;

    var computedDataObj = {};

    computedDataObj.validated = this._selectLatestPhoneNumberOfStatus(_phoneNumberHistoryData, 'verified');
    computedDataObj.unvalidated = this._selectLatestPhoneNumberOfStatus(_phoneNumberHistoryData, 'awaiting_customer_input');
    if (!computedDataObj.unvalidated) {
      computedDataObj.unvalidated = this._selectLatestPhoneNumberOfStatus(_phoneNumberHistoryData, 'unverified');
    }
    computedDataObj.awaiting_customer_input = this._selectLatestPhoneNumberOfStatus(_phoneNumberHistoryData, 'awaiting_customer_input');

    computedDataObj.awaiting_customer_input_formatted = Formatters.formatPhone(computedDataObj.awaiting_customer_input);
    computedDataObj.validated_formatted = Formatters.formatPhone(computedDataObj.validated);
    computedDataObj.unvalidated_formatted = Formatters.formatPhone(computedDataObj.unvalidated);
    computedDataObj.formatted = this._computeFormatedPhoneNumber(computedDataObj.validated, computedDataObj.unvalidated);

    this.presenter.setModelProperty('account_phone_numbers.computed', computedDataObj);
    this.presenter.setModelProperty('account_phone_numbers.isParsed', true);
  };

  this._selectLatestPhoneNumberOfStatus = function (data, status) {
    var filteredData = data.filter(function (num) {
      return num.verification_status === status;
    });
    if (filteredData.length === 0) return null;

    var latestId = Math.max.apply(Math, filteredData.map(function (p) {
      return p.id;
    }));

    var latestObj = $.grep(data, function (w) {
      return w.id == latestId;
    });

    return typeof latestObj[0].phone_number === 'undefined' ? null : latestObj[0].phone_number;
  };

  this._computeFormatedPhoneNumber = function (num1, num2) {
    if (num1) {
      return Formatters.formatPhone(num1);
    }
    if (num2) {
      return Formatters.formatPhone(num2);
    }
    return null;
  };

  this.modelExists = function () {
    return !!this.presenter.models.account_phone_numbers;
  };

  /*
   getCurrentNumber: gets current phone number from the account_phone_numbers model
   The order of retrieval: 1) Validated 2) Awaiting Validation 2) Unvalidated 
   returns '' when none of the items in order exists
  */
  this.getCurrentNumber = function () {
    if (this.modelExists()) {
      var unvalidatedNumber = this.presenter.getModelProperty('account_phone_numbers.computed.unvalidated');
      var validatedNumber = this.presenter.getModelProperty('account_phone_numbers.computed.validated');
      var awaitingValidationNumber = this.presenter.getModelProperty('account_phone_numbers.computed.awaiting_customer_input');

      if (validatedNumber !== null) {
        return validatedNumber;
      }
      if (awaitingValidationNumber && validatedNumber === null) {
        return awaitingValidationNumber;
      }
      if (unvalidatedNumber && validatedNumber === null) {
        return unvalidatedNumber;
      }
    } else {
      return '';
    }
  };

  this.destroyClass = function () {};

  this._constructor(initCallback);
}